import * as React from "react";
import { SVGProps } from "react";
export function BriefCaseBlueIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={11}
      height={12}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.27 2.923h8.46s.77 0 .77.77v6.538s0 .769-.77.769H1.27s-.77 0-.77-.77V3.693s0-.769.77-.769Z"
        stroke="#21597A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m.5 6.223 4.564 1.35c.285.083.587.083.872 0l4.564-1.35M3.828 2.923V1.77A.77.77 0 0 1 4.598 1h1.801a.77.77 0 0 1 .77.77v1.153"
        stroke="#21597A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
